angular.module('natgeo').controller('Level3BuildScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ColorizeFactory', 'CommonFunctions', 'UserProgress', 'ScreenView',
function Level3BuildScreen($scope, element, ScreenFactory, manager, container, ColorizeFactory, CommonFunctions, UserProgress, ScreenView)
{
	var screen = ScreenFactory( 'level3_build', element );

	// Store the current state so it can be restored later.
	screen.store();

	// How many times the screen has reloaded
	screen.loads = 0;

	// Before the screen is loaded
	screen.on('introBefore', function()
	{
		if ( screen.loads > 0 )
		{
			// Restore screen to initial values
			screen.restore( ScreenView, container, $scope );
		}

		// Enables dragging and dropping
		screen.initializeDragDrop();

		// Reset selections
		screen.currentPower = {};
		screen.currentEffector = {};
		screen.currentSensors = {};
		screen.countPower = 0;
		screen.countEffector = 0;
		screen.countSensor = 0;
		screen.readyVisible = false;
		screen.meterPower = 0;
		screen.meterWeight = 0;
		screen.meterSensor = 0;
	
		// Displays the help modal with the given name
		$scope.help = CommonFunctions.help( screen );
		
		// Loaded!
		screen.loads++;
	});

	// Enables dragging and dropping
	screen.initializeDragDrop = function()
	{
		screen.view.find('.draggable').draggable(
		{
			helper: 'clone',
			start: function(e, ui)
			{
				$(ui.helper).css('zIndex', 100);
			}
		});
		screen._beeDrop.droppable(
		{
			drop: function(e, ui)
			{
				ui.draggable.parent().click();
			}
		});
	};
	
	// Moving the meter
	anim8.save('buildMoveMeter', { // {762,427} (212x135) -> {50,270}
		keyframe: {
			from: {
				translate: 0
			},
			to: {
				translate: {
					x: (50 - 762) / 212 * 100, 
					y: (270 - 427) / 135 * 100
				}
			}
		},
		units: {
			translate: '%'
		}
	});

	screen.powers = {
		powerSmall: 2,
		powerMedium: 3,
		powerLarge: 5,
		effectorStinger: 0,
		effectorLight: 0,
		effectorPollinator: 0,
		sensorOptic: 0,
		sensorOceli: 0,
		sensorAccel: 0,
		sensorGyro: 0,
		sensorCamera: 0
	};

	screen.weights = {
		powerSmall: 1,
		powerMedium: 2,
		powerLarge: 3,
		effectorStinger: 0.5,
		effectorLight: 1,
		effectorPollinator: 0.5,
		sensorOptic: 0.3,
		sensorOceli: 0.3,
		sensorAccel: 0.3,
		sensorGyro: 0.3,
		sensorCamera: 0.3
	};

	screen.sensors = {
		powerSmall: 0,
		powerMedium: 0,
		powerLarge: 0,
		effectorStinger: 0,
		effectorLight: 0,
		effectorPollinator: 0,
		sensorOptic: 1,
		sensorOceli: 1,
		sensorAccel: 1,
		sensorGyro: 1,
		sensorCamera: 1
	};

	// Hides or Shows the ready button
	screen.toggleReadyButton = function()
	{
		if ( screen.countPower > 0 && screen.countEffector > 0 && screen.countSensor > 0 )
		{
			if ( !screen.readyVisible )
			{
				screen.introduce( 'ready', 'nextIn 0.5s' );
				screen.readyVisible = true;
			}
		}
		else
		{
			if ( screen.readyVisible )
			{
				screen.outroduce( 'ready', 'nextOut 0.5s' );
				screen.readyVisible = false;
			}
		}
	};

	// Adjusts the meter of the given type by an amount
	screen.adjustMeter = function(type, amountMap)
	{
		var next = 0;
		for ( var prop in screen.currentPower )    next += amountMap[ screen.currentPower[ prop ] ];
		for ( var prop in screen.currentEffector ) next += amountMap[ screen.currentEffector[ prop ] ];
		for ( var prop in screen.currentSensors )  next += amountMap[ screen.currentSensors[ prop ] ];

		var nextRounded = Math.round( next );
		var current = screen[ 'meter' + type ];
		var i = Math.round( current );
		var k = Math.min( 5, nextRounded );

		if ( i !== k )
		{
			var delay = 0;
			if ( i < k )
			{
				for (var n = Math.max(0, i) + 1; n <= k; n++)
				{
					screen.introduce( type + n, 'zoomIn 0.3s ~' + delay );
					delay += 50;
				}
			}
			// i > k
			else
			{
				for (var n = i; n > k; n--)
				{
					screen.outroduce( type + n, 'zoomOut 0.3s ~' + delay );
					delay += 50;
				}
			}
		}

		screen[ 'meter' + type ] = nextRounded;
		UserProgress[ 'Bee' + type ] = nextRounded;
	};

	// Updates the meters
	screen.updateMeters = function()
	{
		screen.adjustMeter( 'Power', screen.powers );
		screen.adjustMeter( 'Weight', screen.weights );
		screen.adjustMeter( 'Sensor', screen.sensors );
	};

	// The image used for the dots.
	$scope.dot = 'dot';

	screen.updateDotImage = function()
	{
		if ( UserProgress.BeeWeight >= 5 && UserProgress.BeeSensor >= 5 )
		{
			$scope.dot = 'dot_red';
		}
		else if ( UserProgress.BeeWeight >= 4 && UserProgress.BeeSensor >= 4 )
		{
			$scope.dot = 'dot_yellow';
		}
		else
		{
			$scope.dot = 'dot';
		}
	};

	// Sets the currently selected power
	$scope.setPower = function(power, part)
	{
		if ( !(power in screen.currentPower ) )
		{
			for ( var otherPower in screen.currentPower )
			{
				screen.outroduce( otherPower, 'fadeOut 0.4s' );	
				screen.outroduce( otherPower + 'Text', 'fadeOut 0.4s' );	
				screen.outroduce( screen.currentPower[ otherPower ], 'fadeOut 0.4s' );	
			}
			screen.introduce( power, 'fadeIn 0.4s' );
			screen.introduce( power + 'Text', 'fadeIn 0.4s' );
			screen.introduce( part, 'fadeIn 0.4s' );
			screen.currentPower = {};
			screen.currentPower[ power ] = part;
			screen.countPower = 1;
			screen.updateMeters();
			screen.updateDotImage();
		}
		screen.toggleReadyButton();
	};

	// Sets the currently selected effector
	$scope.setEffector = function(effector, part, canPollinate)
	{
		if ( !(effector in screen.currentEffector ) )
		{
			for ( var otherEffector in screen.currentEffector )
			{
				screen.outroduce( otherEffector, 'fadeOut 0.4s' );
				screen.outroduce( otherEffector + 'Text', 'fadeOut 0.4s' );	
				screen.outroduce( screen.currentEffector[ otherEffector ], 'fadeOut 0.4s' );	
			}
			screen.introduce( effector, 'fadeIn 0.4s' );
			screen.introduce( effector + 'Text', 'fadeIn 0.4s' );
			screen.introduce( part, 'fadeIn 0.4s' );
			screen.currentEffector = {};
			screen.currentEffector[ effector ] = part;
			screen.countEffector = 1;
			screen.updateMeters();
			screen.updateDotImage();
		}
		screen.toggleReadyButton();

		// Can the bee pollinate the flowers?
		UserProgress.BeeCanPollinate = canPollinate;
	};

	// Sets the currently selected sensors
	$scope.setSensor = function(sensor, part)
	{
		if ( sensor in screen.currentSensors )
		{
			screen.outroduce( sensor, 'fadeOut 0.4s' );
			screen.outroduce( sensor + 'Text', 'fadeOut 0.4s' );
			screen.outroduce( part, 'fadeOut 0.4s' );
			delete screen.currentSensors[ sensor ];
			screen.countSensor--;
		}
		else
		{
			screen.introduce( sensor, 'fadeIn 0.4s' );
			screen.introduce( sensor + 'Text', 'fadeIn 0.4s' );
			screen.introduce( part, 'fadeIn 0.4s' );
			screen.currentSensors[ sensor ] = part;
			screen.countSensor++;
		}
		screen.updateMeters();
		screen.updateDotImage();
		screen.toggleReadyButton();
	};

	// Ready for test!
	$scope.ready = function()
	{
		screen.view.find('.hideOnReady')
			.not('.hidden')
			.stopIt()
			.dataPlay('outro')
			.applyInitialState()
			.animators()
			.once('finished', function()
			{
				$(this.e).addClass('hidden');
			})
		;

		screen._meter.play( 'buildMoveMeter' ).data( 'intro', 'buildMoveMeter' );

		screen.introduce( 'next', 'slideInDownRight ~2s' );
		screen.introduce( 'test', 'flipInX ~0.5s' );
	};

	// The next screen is the test (bee) screen
	$scope.next = function()
	{
		manager.transition('level3_bee');
	};
	
	// The previous screen is the plan screen
	$scope.prev = function()
	{
		manager.transition('level3_plan');
	};
	
}]);